// Content.jsx
import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import Post from "./Post";
import styles from "./Content.module.css"; // Import CSS module

const Content = ({
  posts,
  handleBookmark,
  handleRemoveBookmark,
  handleRemove,
}) => {
  return (
    <div className={styles.contentContainer}>
      {posts.map((post) => (
        <div key={post.id}>
          <Link to={`?view=content&postId=${post.id}`} className={styles.link}>
            <Post
              post={post}
              handleBookmark={handleBookmark}
              handleRemoveBookmark={handleRemoveBookmark}
              handleRemove={handleRemove} // Pass handleRemove to Post
            />
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Content;
